// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.w-e-text[data-v-bb9462e6] {\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
